import { featured, hotList } from "@/mocks/homeData";

function TrendIcon({ trend }: { trend: "up" | "down" | "flat" }) {
  if (trend === "up") {
    return (
      <span className="flex items-center gap-0.5 text-primary-500">
        <i className="ri-arrow-up-line text-sm" />
      </span>
    );
  }
  if (trend === "down") {
    return (
      <span className="flex items-center gap-0.5 text-foreground-400">
        <i className="ri-arrow-down-line text-sm" />
      </span>
    );
  }
  return (
    <span className="flex items-center gap-0.5 text-secondary-600">
      <i className="ri-subtract-line text-sm" />
    </span>
  );
}

export default function HotZone() {
  return (
    <section id="hot" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-6 px-4 md:grid-cols-5 md:px-6">
        {/* 本周主打 */}
        <article className="md:col-span-3 overflow-hidden rounded-3xl bg-background-50 p-5">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
            <i className="ri-megaphone-line" /> {featured.tag}
          </span>
          <h3 className="mt-3 font-heading text-xl text-foreground-950 md:text-2xl">{featured.title}</h3>
          <p className="mt-2 text-sm text-foreground-600">{featured.caption}</p>
          <div className="group relative mt-4 overflow-hidden rounded-2xl">
            <img
              src={featured.img}
              alt={featured.alt}
              className="aspect-[16/11] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
            <span className="absolute bottom-3 left-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-600">
              🔥 围观 88.6w
            </span>
          </div>
        </article>

        {/* 热搜榜 */}
        <aside className="md:col-span-2 rounded-3xl bg-background-50 p-5">
          <div className="flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-xl text-foreground-950">
              <i className="ri-fire-fill text-primary-500" />
              今日热搜梗
            </h3>
            <span className="text-xs text-foreground-400">每 10 分钟刷新</span>
          </div>
          <ol className="mt-4 flex flex-col">
            {hotList.map((h) => (
              <li
                key={h.rank}
                className="flex items-center gap-3 rounded-xl px-2 py-2.5 transition-colors hover:bg-background-100"
              >
                <span
                  className={`w-6 shrink-0 text-center font-heading text-base ${
                    h.rank <= 3 ? "text-primary-500" : "text-foreground-300"
                  }`}
                >
                  {h.rank}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-800">
                  {h.word}
                </span>
                <span className="shrink-0 text-xs text-foreground-400">{h.heat}</span>
                <TrendIcon trend={h.trend} />
              </li>
            ))}
          </ol>
        </aside>
      </div>
    </section>
  );
}